export { TabComponent } from './components';
export { TabsContainer } from './containers';
export { TabModule } from './angular-tabs-component.module';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/index.ts